<template>
	<v-bottom-sheet v-model="sheet" content-class="rounded-t-lg">
		<v-card class="rounded-t-lg">
			<v-toolbar flat class="text-h6 text-uppercase">
				<v-spacer/>
				{{$t('Profile.balance-details')}}
				<v-spacer/>
			</v-toolbar>

			<v-card-text class="px-4 pb-1">
				<v-simple-table v-if="custodyDetails.length" dense>
					<template v-slot:default>
						<thead class="primary white--text">
							<tr>
								<th class="white--text">{{ $T('inputs.type') }}</th>
								<th class="white--text">{{ $T('inputs.name') }}</th>
								<th class="white--text">{{ $T('inputs.amount') }} ({{ $T('currency') }})</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="detail in custodyDetails" :key="detail.id">
								<td>{{ typeLabel(detail.custodyDetailsType) }}</td>
								<td>{{ detail.name }}</td>
								<td>{{ $options.filters.formatNumber(detail.amount) }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>

				<div v-else class="d-flex flex-column justify-center align-center py-8">
					<v-icon x-large class="mb-3">mdi-cash-remove</v-icon>
					<span class="grey--text text--darken-2">{{ $t('Profile.no-balance-details-to-show') }}</span>
				</div>
			</v-card-text>

			<v-card-actions class="pt-0">
				<v-spacer/>
				<v-btn
					text
					block
					class="font-weight-bold"
					color="grey darken-2"
					@click="sheet = false"
				>
					{{$T('done')}}
				</v-btn>
				<v-spacer/>
			</v-card-actions>
		</v-card>
	</v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex'
import { custodyDetailsType } from '@/helpers/enums'

const TYPE_LABEL_KEYS = {
	[custodyDetailsType.delivered]: 'delivered',
	[custodyDetailsType.received]: 'received',
	[custodyDetailsType.expenses]: 'expenses',
	[custodyDetailsType.returnedForCustomers]: 'returned-for-customers'
}

export default {
	name: 'StockDetailsSheet',

	data() {
		return {
			sheet: false
		}
	},

	computed: {
		...mapState({
			custodyDetails: state => state.profile.custodyDetails
		})
	},

	methods: {
		typeLabel(type) {
			const key = TYPE_LABEL_KEYS[type]
			return key ? this.$t(`Profile.custody-detail-type.${key}`) : '-'
		},

		activeSheet() {
			this.sheet = true
		}
	}
}
</script>
